import Overlay from "../components/overlay";
import {
    ArcElement,
    BarController,
    BarElement,
    CategoryScale,
    Chart,
    Colors,
    Legend,
    LinearScale,
    LineController,
    LineElement,
    PieController,
    Tooltip,
} from 'chart.js'

Chart.register(
    LineController,
    LineElement,
    PieController,
    ArcElement,
    BarController,
    BarElement,
    LinearScale,
    CategoryScale,
    Colors,
    Tooltip,
    Legend,
)


export function updateURLParams(params) {
  // Získá aktuální URL a vytvoří objekt URL
  const url = new URL(window.location);

  // Projdi všechny klíče a hodnoty z předaného objektu (params)
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      // Přidej nebo aktualizuj hodnotu parametru v URL
      url.searchParams.set(key, params[key]);
    }
  }
  // history.pushState uloží nový stav bez reloadu stránky
  history.pushState({}, '', url);
}

export function getURLParam(param) {
    return new URL(window.location).searchParams.get(param)
}

export function changeLocation(url, target=null) {
    (target || window).dispatchEvent(new CustomEvent('location_changed', {
        detail: `${url}`,
        cancelable: true,
        bubbles: true,
        composed: true
    }))
}

function cloneEvent(event, new_target) {
    const new_event = new CustomEvent(event.type, {
        bubbles: event.bubbles,
        cancelable: event.cancelable,
        detail: event.detail,
    });
    new_event.altKey = event.altKey;
    new_event.ctrlKey = event.ctrlKey;
    new_event.shiftKey = event.shiftKey;
    new_event.metaKey = event.metaKey;
    new_event.button = event.button;
    new_event.buttons = event.buttons;
    new_event.clientX = event.clientX;
    new_event.clientY = event.clientY;
    new_event.relatedTarget = event.relatedTarget;
    new_event.screenX = event.screenX;
    new_event.screenY = event.screenY;
    Object.defineProperty(new_event, 'target', {
        value: new_target,
        writable: false,
    });
    return new_event
}

export function bindEvent(DOMElement, event_type, child_query=null, include_nested=true, handler) {
    const target_query = child_query
    if (target_query && include_nested)
        child_query = `${child_query}, ${child_query} *`;
    return DOMElement.addEventListener(event_type, (event) => {
        if (! child_query || event.target.matches(child_query)) {
            if (child_query && include_nested && !event.target.matches(target_query))
                event = cloneEvent(event, event.target.closest(target_query));
            handler(event)
        }
    })
}


export function createNotification(message, type) {
  let notification = document.createElement("div")
  notification.classList.add("notification", "is-" + type, "mb-4",);
  notification.innerHTML = `<button type="button" class="delete" onclick="this.closest('.notification').remove()"></button> ${message}`
  return notification
}


export function formatErrorData(errorData) {
    if (typeof errorData === 'string') {
        return errorData;  // Pokud je to plain text, vrátí ho přímo
    } else if (typeof errorData === 'object' && errorData !== null) {
        // Pokud je to objekt, vytvoří strukturovaný výpis
        return Object.keys(errorData).map(key => {
            const messages = errorData[key];
            if(Array.isArray(messages) && typeof messages[0] === 'string') {
                return `<strong>${key}:</strong><br />` +
                    messages.map(msg => `&nbsp;&nbsp;- ${msg}`).join('<br />');
            } else if(Array.isArray(messages) && typeof messages[0] === 'object') {
                return messages.map(msgObj => formatErrorData(msgObj)).join('<br />');
            }
        }).join('<br />');
    }
    return 'Unknown error format';
}

/*
 * Emphasize error fields in form and display error messages below them
 */
export function markErrorFields(errorData) {
    if(errorData.errors){
        errorData.errors.forEach(error => {
            markErrorFields(error);
        });
        errorData.errors = errorData.errors.filter((obj) => Object.keys(obj).length > 0);
        if(Object.keys(errorData.errors).length === 0) delete errorData['errors'];
    }
    const keys_to_delete = [];
    Object.keys(errorData).forEach(key => {
        if(typeof errorData[key] === "object" && !Array.isArray(errorData[key])){
            markErrorFields(errorData[key]); // Nest further if the keys are deeper down the object
        }
        // Get the last input that is found from the selection (we should better check for visibility but this should be enough)
        const inputs = document.querySelectorAll(`[name="${key}"]`);
        let input = null;
        if(inputs.length > 0) {
            input = inputs[inputs.length - 1];
        }

        if (input) {
            if(input.type === "hidden"){
                return
            }
            let isDangerEl = [input];
            const errorLabel = document.querySelector(`.${key}-error`);
            if(input.classList.contains("multicomplete")) {
                isDangerEl = Array.from(input.parentNode.querySelectorAll("input[type='text']"));
            }
            else if(input.classList.contains("autocomplete")) {
                isDangerEl = Array.from(input.parentNode.querySelectorAll(".input"));
            }
            else if(input.classList.contains("file-input")) {
                isDangerEl = [input.closest(".file")];
            }
            else if(input.tagName === "SELECT") {
                isDangerEl = [input.parentNode];
            }

            isDangerEl.forEach(el => el.classList.add('is-danger'));
            input.classList.add('is-danger');

            if(Array.isArray(errorData[key]) && typeof errorData[key][0] === 'string' && errorLabel) {
                errorLabel.innerHTML = errorData[key].join('<br />');
                errorLabel.display = 'block';
            } else if(typeof errorData[key] === 'string' && errorLabel) {
                errorLabel.innerHTML = errorData[key];
                errorLabel.display = 'block';
            }
            // dispatch the error event to show the error message if hidden (only used in animal picker)
            errorLabel?.dispatchEvent(new CustomEvent("error", {
                bubbles: true
            }));

            input.addEventListener('input', () => {
                input.classList.remove('is-danger');
                isDangerEl.forEach(el => el.classList.remove('is-danger'));
                if (errorLabel) {
                    errorLabel.innerHTML = '';
                }
            });
            input.addEventListener('changed', () => {
                input.classList.remove('is-danger');
                isDangerEl.forEach(el => el.classList.remove('is-danger'));
                if (errorLabel) {
                    errorLabel.innerHTML = '';
                }
            });
            // remove the error from the errorData
            keys_to_delete.push(key);
        }
    });
    keys_to_delete.forEach(key => delete errorData[key]);
}


export function submitForm(formElement, additional_data={}, dataHandler=null, errorHandler=null, config={}, notificationsWrapper=null, additionalConfig={}) {
  window.Overlay.instance.show("Processing data...")
  const formData = new FormData(formElement)
    if (additional_data) {
        for (const key in additional_data) {
            formData.set(key, additional_data[key])
        }
    }
  let notifications_wrapper = notificationsWrapper ?? formElement.querySelector('#formNotifications');
  if (notifications_wrapper)
    notifications_wrapper.innerHTML = ''
  return axios.post(formElement.getAttribute("action"), formData, config)
    .then(response => {
      // console.log(response)
      if (notifications_wrapper) {
        let notif_message = ""
        if (Array.isArray(response.data)) {
            const what = response.data[0]._what
            const ids = response.data.map(x => x.id)
            notif_message = `<strong>Success:</strong> <a href="/list/${what}?_url&id__in=${ids.join(",")}">link</a>`
        } else if(response.data._link) {
            notif_message = `<strong>Success:</strong> <a href="${response.data._link}">link</a>`
        } else {
            notif_message = '<strong>Success!</strong>'
        }
        notifications_wrapper.appendChild(
            createNotification(
                notif_message,
                'success'
            )
        )
      }

      if (response.status === 202) {
          try {
              window.bgTaskNotifier.resetTimer();
          } catch {
              console.warn("Server responded with 202 but fetching new tasks failed.")
          }
      }

      if (dataHandler) {
        dataHandler(response)
        if(additionalConfig.preventModalClosing === true) {

        } else {
            ModalDialog.instance.closeForm();
        }
      }
    })
    .catch(error => {
      console.error("Error submitting form: ", error)
      markErrorFields(error.response.data);
      if (notifications_wrapper && (error.response.data.length > 0 || Object.keys(error.response.data).length > 0)) {
          notifications_wrapper.appendChild(
              createNotification(
                  `<strong>${error.response.statusText}</strong><br />${formatErrorData(error.response.data)}`,
                  'danger'
              )
          )
      }

      if (errorHandler) {
        errorHandler(error)
      } else {
        throw error;
      }
    })
    .finally(() => {
      Overlay.instance.hide()
    });
}

export function escapeSpecialCSSChars(str) {
    ["!", '"', "'", "#", ".", "(", ")", "[", "]", "^", "$", "*"].forEach((char) => {
        str = str.replaceAll(char, `\\${char}`);
    });
    return str;
}

export function newChart(ctx, config) {
    return new Chart(ctx, config)
}

export function debounce(func, delay) {
    let timeout;
    return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}

export function hslToHex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

export function hexToHsl(hex) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Parse r, g, b values
    let r = parseInt(hex.substring(0, 2), 16) / 255;
    let g = parseInt(hex.substring(2, 4), 16) / 255;
    let b = parseInt(hex.substring(4, 6), 16) / 255;

    // Find min and max values to get lightness
    let max = Math.max(r, g, b);
    let min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // Achromatic
    } else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }

        h *= 60;
    }

    return {
        h: Math.round(h),
        s: Math.round(s * 100),
        l: Math.round(l * 100)
    };
}


export function humanReadableSize(bytes) {
    if (bytes < 1024) return bytes + " B";
    let k = 1024, sizes = ["B", "KB", "MB", "GB", "TB"], i = Math.floor(Math.log(bytes) / Math.log(k));
    return (bytes / Math.pow(k, i)).toFixed(1) + " " + sizes[i];
}


export function acGetValues(acSelectElement){
    return Array.from(acSelectElement.options).map(opt => parseInt(opt.value))
}

export function acSetValues(acSelectElement, values){
    // values must be in this format: [{"value": 1}, {"value": 2}...]
    let evt = new CustomEvent("changeValue", {
        detail: {value: values}
    });
    acSelectElement.dispatchEvent(evt);
}

export function acClearValues(acSelectElement){
    acSelectElement.dispatchEvent(new CustomEvent("clearValue"));
}

/*export function getIndividualsIds(form_data) {
    let individuals = new Set()
    individuals = individuals.union(new Set(acGetValues(document.querySelector("select[name='individuals']"))));
    const promises = [];
    ["stocks", "strains", "experimental_groups", "tanks"].forEach(res => {
        let res_ids = [];
        const selectEl = document.querySelector(`[name='${res}']`);
        if (!selectEl) return;
        try {
            res_ids = acGetValues(selectEl);
        } catch (e) {
            console.error(e);
        }
        if (res_ids.length === 0) return;
        let endpoint;
        if (res === "strains") {
            endpoint = `/autocomplete/individual?stock__${res.slice(0, -1)}__in=${res_ids}&pg_size=0`;
        } else {
            endpoint = `/autocomplete/individual?${res.slice(0, -1)}__in=${res_ids}&pg_size=0`;
        }
        promises.push(axios.get(endpoint)
            .then((response) => {
                individuals = individuals.union(new Set(response.data.map(ind => parseInt(ind.value))));
            })
            .catch((error) => {
                console.error(error);
            }));
    })
    return Promise.all(promises).then(() => {
        return individuals
    });
}*/


export function getIndividualsIds(formData) {
    const allowedKeys = ["individuals", "tanks", "stocks", "strains", "experimental_groups"]
    const params = new URLSearchParams()

    for (const key of allowedKeys) {
        if (formData.has(key)) {
            params.append(key, formData.getAll(key).join(","))
        }
    }

    return axios.get("/autocomplete/individuals_from_groups", { params })
        .then(response => {
            return response.data.individuals.map(id => parseInt(id))
        })
        .catch(error => {
            console.error("Chyba při načítání individual IDs:", error)
            return []
        });
}


export function getSelectedValues(wrapperQuery, checkboxQuery=`input[type='checkbox']:checked`) {
    return Array.from(document.querySelector(wrapperQuery).querySelectorAll(checkboxQuery)).map(chb => chb.value)
}

export function reloadComponent(container, url, formElement, additional_data={}, afterReload=null, errorHandler=null) {
    let formData = new FormData(formElement)
    for(const key in additional_data) {
        formData.set(key, additional_data[key])
    }
    axios.post(url, formData)
        .then(response => {
            container.innerHTML = response.data
            if (afterReload) {
                afterReload()
            }
        })
        .catch(error => {
            if (errorHandler) {
                errorHandler(error)
            } else {
                console.error("Error reloading component: ", error)
            }
        })
}

export function runNewScripts(container){
    const scripts = container.querySelectorAll('script');
    scripts.forEach(script => {
        const newScript = document.createElement('script');
        if (script.src) {
            // Pokud má skript src atribut, načti ho jako nový skript
            newScript.src = script.src;
            document.head.appendChild(newScript);
        } else {
            // Pokud nemá src, spustíme inline skript pomocí eval
            eval(script.innerHTML);
        }
    });
}

export function hydrateDropdowns() {
    const dropdowns = document.querySelectorAll('.dropdown:not(.is-hoverable):not([data-ready=true])');

    dropdowns.forEach(dropdown => {
        // Přidej listener na kliknutí na trigger
        // console.log("Hung event listener on dropdown:", dropdown);
        dropdown.dataset.ready = true;
        dropdown.querySelector('.dropdown-trigger')?.addEventListener('click', (event) => {
            event.stopPropagation();
            dropdown.classList.toggle('is-active');
        });
    });

    // Uzavře dropdown při kliknutí mimo něj
    document.addEventListener('click', () => {
        dropdowns.forEach(dropdown => {
            if (!dropdown.querySelector('.dropdown-trigger')) return;
            dropdown.classList.remove('is-active');
        });
    });
}

export function switchTab(sender) {
    console.log("switching to tab", sender.dataset.tab)
    sender.closest('ul').querySelectorAll('li').forEach(e => e.classList.remove('is-active'))
    sender.closest('li').classList.add('is-active')
    const wrapper = sender.closest('div.tabs-wrapper')
    wrapper.querySelectorAll('div[data-tab]').forEach(t => t.classList.add('is-hidden'))
    wrapper.querySelector(`div[data-tab="${sender.dataset.tab}"]`).classList.remove('is-hidden')
}


export function createRandomString(length) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export class AutoIncrementor {
    constructor(config={}) {
        this.startDelayMs = config.startDelayMs ?? 1000;
        this.incrementTimeMsIntervals = config.incrementTimeMsIntervals ?? {
            0: 300,
            10: 100,
            20: 50,
        };
        this.incrementValueIntervals = config.incrementValueIntervals ?? {
            0: 1,
        };
        this.iteration = 0;
        this.timeoutRef = null;
    }

    start(clbk) {
        this.iteration = 0;
        this.iterate(clbk, true);
    }

    iterate(clbk, start=false) {
        if(!start){
            this.iteration++;
        }
        clbk({
            iteration: this.iteration,
            delayMs: this.getValueFromInterval(this.incrementTimeMsIntervals, this.iteration, 300),
            increment: this.getValueFromInterval(this.incrementValueIntervals, this.iteration, 1),
        });
        const delay = start ? this.startDelayMs : this.getValueFromInterval(this.incrementTimeMsIntervals, this.iteration, 300);
        this.timeoutRef = setTimeout(() => {
            this.iterate(clbk)
        }, delay);
    }

    stop() {
        clearTimeout(this.timeoutRef);
    }

    getValueFromInterval(intervalMap, num, defaultVal) {
        const thresholds = Array.from(Object.keys(intervalMap)).map((val) => parseInt(val));
        thresholds.sort()
        let lastKey = null
        for(const key of thresholds) {
            if(num < key) {
                break;
            }
            lastKey = key
        }
        return lastKey ? intervalMap[lastKey] : defaultVal
    }
}
